export default {
  employee: "Employee",
  owner: "Owner",

  subsidiary: "Subsidiary",
  parent: "Holding company",
  sisterCompany: "Sister company",
}
